<div class="focus-input" [ngClass]="{'is-active': active}">
    <input type="text"
        class="input"
        [disabled]="disabled"
        (focus)="onFocus()"
        (focusout)="onFocusout()"
        [(ngModel)]="value"
    />
    <label class="label"
        (click)="setFocus()"
    >{{label}}</label>
</div>
